import { useQuery } from "@tanstack/react-query";
import React, { useEffect, useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import axios from "../../api/axios";
import { destroySession } from "../../helpers/Session";

const Payperiod = () => {
    const navigate = useNavigate();

    const timeoutRef = useRef(null);

    const accesstoken = sessionStorage.getItem('accesstoken');
    const uname = sessionStorage.getItem('uname'); 
    const breadcrumbChildSlug = sessionStorage.getItem('timesheetChildSlug');
    const breadcrumbGrandchildSlug = sessionStorage.getItem('timesheetGrandchildSlug');
    
    const [accessibleDepartments, setAccessibleDepartments] = useState([]);

    const { data: role } = useQuery({
        queryKey: ['userrole']
    });

    const { data: manageddepartments = [] } = useQuery({
        queryKey: ['managedDepartments', uname]
    });

    const { data: managedadjustments = [] } = useQuery({
        queryKey: ['managedAdjustments', uname]
    });
    
    useEffect(() => {
        const combineDepartments = [...manageddepartments, ...managedadjustments];
        const finalDepartments = combineDepartments.filter((value, index, self) => (
            index === self.findIndex((d) => (
                d.department_code === value.department_code && d.department === value.department
            ))
        ));

        if (JSON.stringify(finalDepartments) !== JSON.stringify(accessibleDepartments)) {
            setAccessibleDepartments(finalDepartments);
        }
    }, [manageddepartments, managedadjustments, accessibleDepartments]);

    const currentYear = ((role === 'admin' || role === 'management') || manageddepartments?.length > 1 || managedadjustments?.length > 1) ? breadcrumbGrandchildSlug : breadcrumbChildSlug;

    const { data: payperiods, isLoading: isLoadingPayperiods, error: errorPayperiods } = useQuery({
        queryKey: ['payperiodlists', currentYear],
        queryFn: async () => {
            const res = await axios.get(`payperiods/years/${currentYear}`, {
                headers: { 'Authorization': `Bearer ${accesstoken}` }
            });
            return res.data.response;
        },
        enabled: !!currentYear
    });

    useEffect(() => {
        if (errorPayperiods) {
            if (errorPayperiods.response?.data.status === 'inactive') {
                destroySession();
                clearTimeout(timeoutRef.current);
                timeoutRef.current = setTimeout(() => { navigate('/error'); }, 1000);
            }
        }
    }, [errorPayperiods]);

    const handleSetTimesheetPayperiodData = (id, payperiod) => {
        sessionStorage.setItem('timesheetPayperiod', payperiod);
        sessionStorage.setItem('timesheetPayperiodId', id);

        // MSW-26192: Clear employee data when navigating to a different payperiod
        sessionStorage.removeItem('timesheetEmployee');
        sessionStorage.removeItem('timesheetEmployeeUname');

        if (role === 'manager') {
            sessionStorage.setItem('timesheetGrandchild', payperiod);
            sessionStorage.setItem('timesheetGrandchildSlug', id);
        }
    }


    return (
        <div className={`payperiod card ${isLoadingPayperiods && ' loading'}`}>
            {
                isLoadingPayperiods ? (
                    [...Array(8)].map((_, i) => (
                        <div key={i} className="card-content">
                            <a>
                                <i className="fa fa-folder"></i>
                                <span>Resty Alejo</span>
                            </a>
                        </div>
                    ))
                ) : (
                    payperiods?.map((item) => (
                        <div key={item.id} className="card-content">
                            <NavLink to={((role === 'admin' || role === 'management') || manageddepartments?.length > 1 || managedadjustments?.length > 1) ? `/dtr/timesheets/${breadcrumbChildSlug}/${breadcrumbGrandchildSlug}/${item.id}` : `/dtr/timesheets/${breadcrumbChildSlug}/${item.id}`} title={item.payperiod} onClick={() => { handleSetTimesheetPayperiodData(item.id, item.sdate + ' - ' + item.edate); }}>
                                <i className="fa fa-folder"></i>
                                <span>{item.sdate + ' - ' + item.edate}</span>
                            </NavLink>
                        </div>
                    ))
                )
            }
        </div>
    )
}

export default Payperiod;